/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect } from 'react';

export default function useWhatsChanging(prompt: string, deps: Record<string, any>, logger = console.log) {
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(deps)) {
    useEffect(() => {
      //NOSONAR
      logger(`%c[${prompt}] ${key} changed: `, 'background-color: yellow', value); //NOSONAR
    }, [value, prompt, logger, key]); //NOSONAR
  }
}
